import { gql } from "@apollo/client";

export const ListUserFiles = gql`
  query ListUserFiles(
    $contentType: String!
    $operationType: String
    $status: FileStatus
    $context: String
    $from: String
    $to: String
    $limit: Int
    $offset: Int
  ) {
    listUserFiles(
      contentType: $contentType
      operationType: $operationType
      status: $status
      context: $context
      from: $from
      to: $to
      limit: $limit
      offset: $offset
    ) {
      totalCount
      items {
        id
        userId
        programId
        name
        contentType
        operationType
        status
        requestedAt
        createdAt
        completedAt
        size
        downloadCount
        errorMessage
        context
      }
    }
  }
`;
